interface SettingsPageHeaderProps {
  title: string;
  actions?: React.ReactNode;
}
const SettingsPageHeader = ({ title, actions }: SettingsPageHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-4.5">
      <h1 className="text-2xl font-semibold mb-8 text-white">{title}</h1>
      {actions}
    </div>
  );
};

export default SettingsPageHeader;
